import { css } from 'styled-components';
import { getSpacing, SpacingName, ThemedFunctor } from '@doveit/lego';

export const header: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.margin(theme, [0, 0, SpacingName.MEDIUM, 0])}
`;

export const mainContent: ThemedFunctor = ({
  theme,
}) => css`
  > * + h2,
  > * + .embed {
    ${getSpacing.marginTop(theme, SpacingName.MEDIUM)}
  }

  > * + h3,
  > * + p,
  > * + ul,
  > * + ol,
  > * + img {
    ${getSpacing.marginTop(theme, SpacingName.SMALL)}
  }

  > ul,
  > ol {
    ${getSpacing.paddingLeft(theme, SpacingName.SMALL)}
    display: flex;
    flex-direction: column;
    gap: .5rem;
  }

  > ul {
    list-style: square;
  }

  > ol {
    list-style: decimal;
  }

  > a {
    text-decoration: underline;
  }

  > img {
    max-width: 100%;
    display: block;
    height: auto;
  }
`;

export const secondaryBlocks: ThemedFunctor = ({
  theme,
}) => css`
  > * + * {
    ${getSpacing.marginTop(theme, SpacingName.MEDIUM)}
  }
`;
